import React from 'react';
import './TabBar.css';

/**
 * TabBar
 * @param {Array}  tabs     - [{ id, label }]
 * @param {string} active   - active tab id
 * @param {fn}     onChange - (id) => void
 */
export default function TabBar({ tabs, active, onChange }) {
  return (
    <div className="tab-bar">
      {tabs.map((t) => (
        <button
          key={t.id}
          className={`tab-bar__btn ${active === t.id ? 'tab-bar__btn--active' : ''}`}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
